"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var AppBridgeAppLinks = __importStar(require("@shopify/app-bridge/actions/Link/AppLink"));
var AppBridgeNavigationMenu = __importStar(require("@shopify/app-bridge/actions/Menu/NavigationMenu"));
var useAppBridge_1 = require("../../useAppBridge");
function NavigationMenu(_a) {
    var navigationLinks = _a.navigationLinks, matcher = _a.matcher;
    var app = useAppBridge_1.useAppBridge();
    var _b = react_1.useState(), activeLink = _b[0], setActiveLink = _b[1];
    var items = react_1.useMemo(function () {
        return navigationLinks.map(function (link) {
            var appLink = AppBridgeAppLinks.create(app, link);
            if ((matcher === null || matcher === void 0 ? void 0 : matcher(link, location)) || link.destination === location.pathname) {
                setActiveLink(appLink);
            }
            return appLink;
        });
    }, [app, location.pathname, matcher, navigationLinks]);
    var navigationMenu = react_1.useMemo(function () {
        return AppBridgeNavigationMenu.create(app, {
            items: items,
            active: activeLink,
        });
        /* We want to reuse the same NavigationMenu instance, even when props change
         * (so we don't include all the props in the dependency array).
         * Instead of recreating the component on every change, we use the set method,
         * in the useEffect block below, to dispatch updates when props change.
         */
    }, [app]);
    react_1.useEffect(function () {
        navigationMenu.set({ items: items, active: activeLink });
    }, [activeLink, items]);
    return null;
}
exports.default = NavigationMenu;
